export const NAV_STEP_ATTRIBUTE = 'data-nav-step';

export enum FormNavigationStep {
  Previous = '-1',
  Next = '1',
  Submit = '0',
}
